import { render, staticRenderFns } from "./News261022ENG.vue?vue&type=template&id=1bdc3c76&scoped=true&"
import script from "./News261022ENG.vue?vue&type=script&lang=js&"
export * from "./News261022ENG.vue?vue&type=script&lang=js&"
import style0 from "./News261022ENG.vue?vue&type=style&index=0&id=1bdc3c76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc3c76",
  null
  
)

export default component.exports